module.exports = {
  "id": "key",
  "title": "key",
  "image": "provision/parts/key/key.png",
  "info": [
    {
      "text": "Add a key to your project",
      "image": "provision/parts/key/key.png"
    }
  ],
  "exposedVariables": [],
  "codeImage": "provision/parts/key/key.png"
} ;